/* Inzola additions to Shopify Refresh. Native product and cart scripts remain authoritative. */
(() => {
  if (window.inzolaRefreshLoaded) return;
  window.inzolaRefreshLoaded = true;

  class InzolaStickyPurchase extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.productInfo = document.getElementById('MainProduct-' + this.sectionId);
      this.button = this.querySelector('[data-sticky-submit]');
      this.price = this.querySelector('[data-sticky-price]');
      this.onSubmit = () => {
        const form = document.getElementById('product-form-' + this.sectionId);
        const submit = document.getElementById('ProductSubmitButton-' + this.sectionId);
        if (!form || !submit) return;
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
          this.productInfo?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        form.requestSubmit(submit);
      };
      this.button.addEventListener('click', this.onSubmit);
      this.refresh = () => {
        const submit = document.getElementById('ProductSubmitButton-' + this.sectionId);
        const input = document.getElementById('product-form-' + this.sectionId)?.querySelector('[name="id"]');
        const priceRoot = document.getElementById('price-' + this.sectionId);
        const price = priceRoot?.querySelector('.price--on-sale .price__sale .price-item--sale') || priceRoot?.querySelector('.price__regular .price-item--regular');
        this.button.disabled = !submit || submit.disabled || !input?.value || submit.getAttribute('aria-disabled') === 'true';
        this.button.textContent = submit?.querySelector('span')?.textContent.trim() || 'Kosárba teszem';
        if (price) this.price.textContent = price.textContent.trim();
      };
      this.mutationObserver = new MutationObserver(records => {
        if (records.every(record => this.contains(record.target))) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.refresh);
      });
      if (this.productInfo) this.mutationObserver.observe(this.productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
      const submit = document.getElementById('ProductSubmitButton-' + this.sectionId);
      if (submit) {
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
          document.body.classList.toggle('inzola-sticky-visible', !this.hidden);
        });
        this.intersectionObserver.observe(submit);
      }
      this.refresh();
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onSubmit);
      this.mutationObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('inzola-sticky-visible');
    }
  }
  if (!customElements.get('inzola-sticky-purchase')) customElements.define('inzola-sticky-purchase', InzolaStickyPurchase);

  class InzolaDiscountPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.key = 'inzola-refresh-discount-next';
      this.onClick = async event => {
        if (event.target.closest('[data-discount-close]') || event.target === this.dialog) this.dismiss();
        if (event.target.closest('[data-discount-copy]')) {
          const code = this.querySelector('[data-discount-code]')?.textContent.trim();
          try {
            await navigator.clipboard.writeText(code);
            const status = this.querySelector('[data-copy-status]');
            status.textContent = status.dataset.successMessage;
          } catch {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(this.querySelector('[data-discount-code]'));
            selection.removeAllRanges(); selection.addRange(range);
            this.querySelector('[data-copy-status]').textContent = 'Jelöld ki és másold ki a kedvezménykódot.';
          }
        }
      };
      this.onCancel = event => { event.preventDefault(); this.dismiss(); };
      this.addEventListener('click', this.onClick);
      this.dialog.addEventListener('cancel', this.onCancel);
      if (this.querySelector('[data-discount-success]')) {
        try { localStorage.setItem('inzola-refresh-subscribed', 'true'); } catch { /* Storage may be disabled. */ }
        this.open();
        return;
      }
      if (this.querySelector('[data-discount-error]')) { this.open(); return; }
      if (this.dataset.designMode === 'true') {
        this.onSelect = event => { if (event.target.contains(this)) this.open(); };
        document.addEventListener('shopify:section:select', this.onSelect);
        return;
      }
      try {
        if (localStorage.getItem('inzola-refresh-subscribed') === 'true' || Number(localStorage.getItem(this.key)) > Date.now()) return;
      } catch { /* The newsletter form still works without storage. */ }
      this.timer = setTimeout(() => this.openWhenAvailable(), Number(this.dataset.delay) || 7000);
    }
    openWhenAvailable() {
      if (document.hidden || document.querySelector('cart-drawer.active, dialog[open], .menu-opening')) {
        this.timer = setTimeout(() => this.openWhenAvailable(), 2500);
        return;
      }
      this.open();
    }
    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }
    dismiss() {
      this.dialog.close();
      try { localStorage.setItem(this.key, String(Date.now() + Number(this.dataset.days || 2) * 86400000)); } catch { /* Optional persistence. */ }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.removeEventListener('click', this.onClick);
      this.dialog?.removeEventListener('cancel', this.onCancel);
      if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
    }
  }
  if (!customElements.get('inzola-discount-popup')) customElements.define('inzola-discount-popup', InzolaDiscountPopup);

  document.addEventListener('click', event => {
    const thumb = event.target.closest('.inzola-ultra-gallery__thumbs a, .inzola-air-gallery__thumbs a');
    if (thumb) {
      const gallery = thumb.closest('.inzola-ultra-gallery, .inzola-air-gallery');
      const slide = gallery?.querySelector(thumb.getAttribute('href'));
      const scroller = gallery?.querySelector('.inzola-ultra-gallery__slides, .inzola-air-gallery__slides');
      if (slide && scroller) {
        event.preventDefault();
        const left = slide.offsetLeft - scroller.firstElementChild.offsetLeft;
        scroller.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }
    if (event.target.closest('[data-inzola-scroll-top]')) window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.inzola-cart-upsell__select')) return;
    const label = event.target.closest('form')?.querySelector('[data-inzola-upsell-label]');
    if (label) label.textContent = 'Hozzáadom · ' + event.target.selectedOptions[0].dataset.priceLabel;
  });
  const updateScrollTop = () => {
    const button = document.querySelector('[data-inzola-scroll-top]');
    if (button) button.hidden = window.scrollY < 400;
  };
  window.addEventListener('scroll', updateScrollTop, { passive: true });
  updateScrollTop();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const id = 'InzolaFacts-' + data.sectionId;
      const current = document.getElementById(id);
      const next = data.html.getElementById(id);
      if (current && next) current.innerHTML = next.innerHTML;
    });
  }
})();
